import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { JoveChatMessageSenderRoleEnum } from '@jove-frontend/enums';
import { ChatMessageCardItemTypeEnum, ChatMessagePositionEnum } from '@jove-frontend/types';
import dayjs from 'dayjs';
import { uniqueId } from 'lodash';
import { convertTimeToServerStoredTimeData } from '../time';
export var formatChatDisplaySendTime = function formatChatDisplaySendTime(date) {
  if (!date) return '';
  var now = new Date();
  var diff = now.getTime() - new Date(date).getTime();
  var minutes = Math.floor(diff / 60000);
  var hours = Math.floor(diff / 3600000);
  var days = Math.floor(diff / 86400000);
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return "".concat(minutes, "m ago");
  if (hours < 24) return "".concat(hours, "h ago");
  if (days < 7) return "".concat(days, "d ago");
  return new Date(date).toLocaleDateString('en-US');
};
export var convertLocalInputValueToServerChatPayload = function convertLocalInputValueToServerChatPayload(data) {
  var _ref = data || {},
      message = _ref.message,
      entityName = _ref.entityName;

  return {
    body: message,
    entity_name: entityName
  };
};

var convertToChatMessagePropsData = function convertToChatMessagePropsData(message) {
  var body = message.body,
      options = message.options,
      session_id = message.session_id,
      entity_name = message.entity_name,
      entity_id = message.entity_id,
      card_type = message.card_type,
      pricing_data = message.pricing_data,
      sender_role = message.sender_role,
      email = message.email,
      position = message.position,
      agent_name = message.agent_name,
      direction = message.direction,
      agent_avatar_url = message.agent_avatar_url,
      type = message.type,
      name = message.name,
      from_phone = message.from_phone;
  var positionRightKey = message.positionRightKey || 'inbound';

  var messageData = _objectSpread(_objectSpread({}, message), {}, {
    id: uniqueId()
  });

  if (['agent_offline'].includes(type)) {
    messageData = _objectSpread(_objectSpread({}, messageData), {}, {
      content: "".concat(name, " has quit the chat"),
      description: 'If you have any questions, please contact us.',
      cardType: ChatMessageCardItemTypeEnum.tipAlertText
    });
  } else if (['agent_online'].includes(type)) {
    messageData = _objectSpread(_objectSpread({}, messageData), {}, {
      content: "".concat(name, " has joined the chat"),
      cardType: ChatMessageCardItemTypeEnum.tipAlertText
    });
  } else if (['transfer_closed'].includes(type)) {
    messageData = _objectSpread(_objectSpread({}, messageData), {}, {
      content: "".concat(name || email || 'Agent', " has ended the coversation. You are now chatting with AI."),
      cardType: ChatMessageCardItemTypeEnum.tipAlertText
    });
  } else if (['transfer_accepted'].includes(type)) {
    messageData = _objectSpread(_objectSpread({}, messageData), {}, {
      content: "".concat(name || email, " has joined the chat"),
      cardType: ChatMessageCardItemTypeEnum.tipAlertText
    });
  } else {
    messageData = _objectSpread(_objectSpread({}, messageData), {}, {
      content: body || '',
      senderRole: sender_role || JoveChatMessageSenderRoleEnum.customer,
      sessionId: session_id,
      options: options || [],
      entityName: entity_name,
      entityId: entity_id,
      cardType: card_type || ChatMessageCardItemTypeEnum.common,
      pricingData: pricing_data,
      position: position ? position : direction === positionRightKey ? ChatMessagePositionEnum.right : ChatMessagePositionEnum.left,
      sender: {
        name: agent_name || email || from_phone,
        avatar: agent_avatar_url
      }
    });
  }

  return _objectSpread(_objectSpread({}, message), messageData);
};

export var convertLocalInputValueToChatMessageItemInfo = function convertLocalInputValueToChatMessageItemInfo(data) {
  var messageData = convertToChatMessagePropsData(_objectSpread({}, data));
  return _objectSpread(_objectSpread({}, messageData), {}, {
    list: [messageData],
    created_at: convertTimeToServerStoredTimeData(dayjs().toDate())
  });
};
export var covertServerChatPayloadToChatMessageItemInfo = function covertServerChatPayloadToChatMessageItemInfo(message, config) {
  var messageData = convertToChatMessagePropsData(_objectSpread(_objectSpread({}, message), config));
  return _objectSpread(_objectSpread({}, messageData), {}, {
    list: [messageData]
  });
};